export default {
  'recurringTransfer.modifyWarning':
    'All Transfers associated with this Instruction "<%- name %>" will be Deleted.',
  'recurringTransfer.deleteConfirmMessage':
    'You are about to delete a {0} of {1} from {2} to {3} on {4}.',
  'recurringTransfer.modifyConfirmMessage':
    'You are about to modify a {0} of {1} from {2} to {3} on {4}.',
  'recurringTransfer.confirmMessage':
    'You are about to submit a {0} of {1} from {2} to {3} on {4}.',
  'recurringTransfer.modifyConfirmMessage.header': 'Modify Recurring Instruction',
  'recurringTransfer.confirmMessage.header': 'Create Recurring Instruction',
  'recurringTransfer.name': 'recurring transfer',
  'recurringTransfer.deleteHeader': 'Delete Recurring Transfer'
};
